import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { Dropdown } from '../../../../components/Dropdown';
import type { EmailLengthText, GenerateEmailQuery } from '../../../../domain/generatedEmail';
import { translate } from '../../../../services/i18n';
import { defaultEmailLengthText } from '../../useGenerateEmailsList';

import { StyledRegenerateDropdownOption } from './styles';

type RegenerateDropdownProps = {
  isDropdownOpen: boolean;
  onDropdownClose(): void;
  onRegenerate(length: EmailLengthText): void;
  queries: GenerateEmailQuery[];
  emailIndex: number;
};

const emailLengthText: EmailLengthText[] = ['short', 'medium', 'long', 'xlong', 'xxlong'];

export const RegenerateDropdown = (props: RegenerateDropdownProps) => {
  const { queries, onRegenerate, isDropdownOpen, onDropdownClose, emailIndex } = props;

  const currentTextLength = queries[emailIndex].textLength ?? defaultEmailLengthText;

  const isShortestOption = currentTextLength === emailLengthText[0];
  const isLongestOption = currentTextLength === emailLengthText[emailLengthText.length - 1];

  return (
    <Dropdown
      isOpened={isDropdownOpen}
      onClose={onDropdownClose}
      minWidth={210}
      maxHeight={132}
      placement="on-bottom-left"
    >
      <StyledRegenerateDropdownOption
        isDisabled={isShortestOption}
        onClick={
          !isShortestOption
            ? () => {
                const textLengthToSet = emailLengthText.findIndex((text) => text === currentTextLength) - 1;
                onRegenerate(emailLengthText[textLengthToSet]);
              }
            : undefined
        }
        disabled={isShortestOption}
      >
        <SWReactIcons
          iconName="shorter"
          size="sm"
          iconColor={isShortestOption ? colorsPalettes.midnight[50] : colorsPalettes.carbon[200]}
        />
        {translate('insights.email.regenerate_options.shorter')}
      </StyledRegenerateDropdownOption>
      <StyledRegenerateDropdownOption
        isDisabled={isLongestOption}
        onClick={
          !isLongestOption
            ? () => {
                const textLengthToSet = emailLengthText.findIndex((text) => text === currentTextLength) + 1;
                onRegenerate(emailLengthText[textLengthToSet]);
              }
            : undefined
        }
        disabled={isLongestOption}
      >
        <SWReactIcons
          iconName="longer"
          size="sm"
          iconColor={isLongestOption ? colorsPalettes.midnight[50] : colorsPalettes.carbon[200]}
        />
        {translate('insights.email.regenerate_options.longer')}
      </StyledRegenerateDropdownOption>
      <StyledRegenerateDropdownOption onClick={() => onRegenerate(currentTextLength)}>
        <SWReactIcons iconName="refresh" size="sm" />
        {translate('insights.email.regenerate_options.retry')}
      </StyledRegenerateDropdownOption>
    </Dropdown>
  );
};
